import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Link } from "@/components/common/Link";
export default function PrivacyPolicyHero() {
  return <section id="privacypolicyhero" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-32 pb-16 md:pt-40 md:pb-20 border-b border-border/60">
      {/* Layered decorative ambient planes */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 right-1/4 h-80 w-80 rounded-full bg-chart-1/10 blur-3xl" />
        <div className="absolute top-1/2 left-10 h-72 w-72 rounded-full bg-chart-2/5 blur-3xl" />
        <div className="absolute -bottom-20 right-10 h-64 w-64 rounded-full bg-secondary/80 blur-2xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {/* Layered glass surface card */}
        <div className="rounded-2xl border border-border/80 bg-card/85 p-8 sm:p-12 lg:p-16 shadow-xl backdrop-blur-md">
          {/* Breadcrumb Navigation */}
          <div className="mb-6 sm:mb-8">
            <Breadcrumb>
              <BreadcrumbList className="text-xs sm:text-sm font-medium tracking-normal text-muted-foreground">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/" className="transition-colors hover:text-foreground">
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbSeparator />

                <BreadcrumbItem>
                  <span className="text-muted-foreground select-none">Legal</span>
                </BreadcrumbItem>

                <BreadcrumbSeparator />

                <BreadcrumbItem>
                  <BreadcrumbPage className="font-semibold text-foreground">
                    Privacy Policy
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* H1 Heading */}
          <h1 className="font-serif text-4xl font-normal tracking-tight text-foreground sm:text-5xl lg:text-6xl mb-6">
            Privacy Policy
          </h1>

          {/* Intro Paragraph */}
          <p className="max-w-3xl text-base sm:text-lg lg:text-xl text-muted-foreground leading-relaxed">
            Decatur Heritage Renovations respects your privacy and is committed to
            protecting personal information collected through our consultations, website,
            and home renovation services across Decatur, Georgia and surrounding
            communities.
          </p>
        </div>
      </div>
    </section>;
}